var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.resData,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"resource":"projectrecords","nameProps":{ edit: false },"status-module":"reportProject"}})
}
var staticRenderFns = []

export { render, staticRenderFns }